export default __webpack_public_path__ + "static/media/cfx-costA.57c94ce0.png";